/* eslint-disable no-multi-str */
/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";

import RegistrationNumber from "@vitspot/vit-registration-number";
import {
  parseRawTimetable,
  makeCalendar,
  makeGCalTimetable,
  ParsingError,
  GCALError,
  RateLimitError,
  ICSError,
} from "vit-timetable";

import {
  initializeGapiScript,
  downloadCalendar,
} from "../../utils/timetablecalendar";
import { whatsAppShare } from "../../utils/whatsappshare";

const WHATSAPP_SHARE_LINK = whatsAppShare(
  `*Missing classes already? Add your timetable to Google Calendar and stay organized.*\nhttps://vitspot.com/timetable-calendar/`
);

const isFresher = regnum =>
  regnum.startsWith(new Date().getFullYear().toString().slice(2));

const TimetableCalendar = () => {
  useEffect(() => {
    initializeGapiScript();
  }, []);

  const [timetableRawText, setTimetableRawText] = useState("");
  const [registrationNum, setRegistrationNum] = useState("");

  const addToGoogleCalendar = async () => {
    if (timetableRawText) {
      try {
        const { regNumber } = new RegistrationNumber(registrationNum);
        const { success } = await makeGCalTimetable(
          parseRawTimetable(timetableRawText, registrationNum.toUpperCase()),
          !isFresher(regNumber)
        );
        if (success)
          alert(
            "Calendar created successfully, please check your authorized google account"
          );
        else alert("Something went wrong. Please try again");
      } catch (error) {
        if (error instanceof ParsingError) {
          alert("Something went wrong. Please copy text correctly");
          setTimetableRawText("");
        } else if (error instanceof GCALError)
          alert("Error in authenticating google calendar, try again");
        else if (error instanceof RateLimitError) alert("API limit reached");
        else if (error.error === "popup_closed_by_user")
          alert("Please try again");
        else if (error.error === "access_denied")
          alert(
            "Access denied, please grant the permissions to add your calendar"
          );
        else {
          alert("Invalid registration number");
        }
      }
    } else {
      alert("Please paste the timetable");
    }
  };

  const generateICSFile = () => {
    if (timetableRawText) {
      try {
        const { regNumber } = new RegistrationNumber(registrationNum);
        const { calendar } = makeCalendar(
          parseRawTimetable(timetableRawText, registrationNum.toUpperCase()),
          !isFresher(regNumber)
        );
        downloadCalendar(calendar);
      } catch (error) {
        if (error instanceof ParsingError) {
          alert("Something went wrong. Please copy text correctly");
          setTimetableRawText("");
        } else if (error instanceof ICSError)
          alert("Error in creating ICS file, try again");
        else if (error instanceof RateLimitError) alert("API limit reached");
        else {
          alert("Invalid registration number");
        }
      }
    } else {
      alert("Please paste the timetable");
    }
  };

  return (
    <>
      <div>
        <a
          href="https://t.me/vitx_all"
          target="_blank"
          className="button is-info mb-4 mr-2"
        >
          <span className="icon is-small">
            <i className="fab fa-telegram-plane" />
          </span>
          <span>Join our Telegram Group</span>
        </a>
        <a
          href={WHATSAPP_SHARE_LINK}
          target="_blank"
          className="button is-success mb-4 mr-2"
        >
          <span className="icon is-small">
            <i className="fab fa-whatsapp" />
          </span>
          <span>Share on WhatsApp</span>
        </a>
        <br />
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/B3PejnJJbyc"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
        <br />
        <br />
        <div className="control mb-6">
          <input
            className="input mb-4"
            type="text"
            placeholder="Enter your registration number"
            onChange={e => {
              setRegistrationNum(e.target.value);
            }}
          />
          <textarea
            rows="10"
            className="textarea has-fixed-size"
            placeholder="Paste your timetable"
            value={timetableRawText}
            onChange={e => setTimetableRawText(e.target.value)}
          />
        </div>
        <div className="is-flex is-justify-content-center">
          <a
            className="button  is-normal is-primary mb-2 mr-2"
            onClick={() => {
              generateICSFile();
            }}
          >
            <span>Download ics file</span>
          </a>
          <a
            className="button is-normal is-primary mb-2 mr-2"
            onClick={() => {
              addToGoogleCalendar();
            }}
          >
            <span>Add to Google Calendar</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default TimetableCalendar;
